/**
 * @generated SignedSource<<206d1cfac82db96873502f5268a2f47c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ScheduleTemplatePeriod_period"
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "order": "ASC"
            }
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleTemplateId",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v10 /*: any*/)
        ],
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTimeOfDay",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTimeOfDay",
        "storageKey": null
    }, v14 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "MINUTE"
        }
    ], v15 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        }
    ], v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleTemplatePeriodDayConnection",
        "kind": "LinkedField",
        "name": "days",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ScheduleTemplatePeriodDayEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ScheduleTemplatePeriodDay",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "weekday",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dayInPeriod",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScheduleTemplatePeriod",
                                "kind": "LinkedField",
                                "name": "period",
                                "plural": false,
                                "selections": [
                                    (v3 /*: any*/),
                                    (v9 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentType",
                                "kind": "LinkedField",
                                "name": "groupedShifts",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentTypeGroupingKey",
                                        "kind": "LinkedField",
                                        "name": "group",
                                        "plural": false,
                                        "selections": [
                                            (v11 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ScheduleTemplateShiftGroup",
                                        "kind": "LinkedField",
                                        "name": "shiftsGroups",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ScheduleTemplateShiftGroupGroupingKey",
                                                "kind": "LinkedField",
                                                "name": "group",
                                                "plural": false,
                                                "selections": [
                                                    (v12 /*: any*/),
                                                    (v13 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": (v14 /*: any*/),
                                                        "concreteType": "TimeSpanUnitValue",
                                                        "kind": "LinkedField",
                                                        "name": "duration",
                                                        "plural": false,
                                                        "selections": (v15 /*: any*/),
                                                        "storageKey": "duration(unit:\"MINUTE\")"
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Event",
                                                        "kind": "LinkedField",
                                                        "name": "event",
                                                        "plural": false,
                                                        "selections": [
                                                            (v3 /*: any*/),
                                                            (v16 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ScheduleTemplateShift",
                                                "kind": "LinkedField",
                                                "name": "shifts",
                                                "plural": true,
                                                "selections": [
                                                    (v3 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "unit",
                                                                "value": "HOUR"
                                                            }
                                                        ],
                                                        "concreteType": "TimeSpanUnitValue",
                                                        "kind": "LinkedField",
                                                        "name": "duration",
                                                        "plural": false,
                                                        "selections": (v15 /*: any*/),
                                                        "storageKey": "duration(unit:\"HOUR\")"
                                                    },
                                                    (v11 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ScheduleTemplateShiftBreak",
                                                        "kind": "LinkedField",
                                                        "name": "breaks",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": (v14 /*: any*/),
                                                                "concreteType": "TimeSpanUnitValue",
                                                                "kind": "LinkedField",
                                                                "name": "offsetEnd",
                                                                "plural": false,
                                                                "selections": (v15 /*: any*/),
                                                                "storageKey": "offsetEnd(unit:\"MINUTE\")"
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": (v14 /*: any*/),
                                                                "concreteType": "TimeSpanUnitValue",
                                                                "kind": "LinkedField",
                                                                "name": "offsetStart",
                                                                "plural": false,
                                                                "selections": (v15 /*: any*/),
                                                                "storageKey": "offsetStart(unit:\"MINUTE\")"
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "type",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    },
                                                    (v13 /*: any*/),
                                                    (v12 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "assignedEntity",
                                                        "plural": false,
                                                        "selections": [
                                                            (v5 /*: any*/),
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    (v3 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Asset",
                                                                        "kind": "LinkedField",
                                                                        "name": "asset",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v3 /*: any*/),
                                                                            (v17 /*: any*/),
                                                                            (v16 /*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    (v18 /*: any*/),
                                                                    (v19 /*: any*/)
                                                                ],
                                                                "type": "SchedulableAsset",
                                                                "abstractKey": null
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    (v3 /*: any*/),
                                                                    (v18 /*: any*/),
                                                                    (v19 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "User",
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v3 /*: any*/),
                                                                            (v17 /*: any*/),
                                                                            (v20 /*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "type": "SchedulableUser",
                                                                "abstractKey": null
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    (v3 /*: any*/)
                                                                ],
                                                                "type": "Node",
                                                                "abstractKey": "__isNode"
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ScheduleShiftAssetValidation",
                                                        "kind": "LinkedField",
                                                        "name": "assetValidations",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "SchedulableAsset",
                                                                "kind": "LinkedField",
                                                                "name": "schedulableAsset",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Asset",
                                                                        "kind": "LinkedField",
                                                                        "name": "asset",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v3 /*: any*/),
                                                                            (v16 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "assetNumber",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "validateProficiency",
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    (v3 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "SchedulableUser",
                                                                "kind": "LinkedField",
                                                                "name": "schedulableUser",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "User",
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v20 /*: any*/),
                                                                            (v3 /*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    (v3 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "AssignmentType",
                                                                "kind": "LinkedField",
                                                                "name": "userAssignmentType",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v10 /*: any*/),
                                                                    (v3 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "AssetProficiencyValidation",
                                                                "kind": "LinkedField",
                                                                "name": "assetProficiency",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "isValid",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplatePeriod_cloneScheduleTemplatePeriodMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CloneScheduleTemplatePeriodPayload",
                    "kind": "LinkedField",
                    "name": "cloneScheduleTemplatePeriod",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleTemplatePeriod",
                            "kind": "LinkedField",
                            "name": "periodEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplatePeriod",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplate",
                                            "kind": "LinkedField",
                                            "name": "scheduleTemplate",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": "periods",
                                                    "args": (v4 /*: any*/),
                                                    "concreteType": "ScheduleTemplatePeriodConnection",
                                                    "kind": "LinkedField",
                                                    "name": "__ScheduleTemplate_periods_connection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTemplatePeriodEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleTemplatePeriod",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": "__ScheduleTemplate_periods_connection(order:{\"order\":\"ASC\"})"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplatePeriod_cloneScheduleTemplatePeriodMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CloneScheduleTemplatePeriodPayload",
                    "kind": "LinkedField",
                    "name": "cloneScheduleTemplatePeriod",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleTemplatePeriod",
                            "kind": "LinkedField",
                            "name": "periodEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplatePeriod",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v21 /*: any*/),
                                        (v16 /*: any*/),
                                        (v9 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplate",
                                            "kind": "LinkedField",
                                            "name": "scheduleTemplate",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v4 /*: any*/),
                                                    "concreteType": "ScheduleTemplatePeriodConnection",
                                                    "kind": "LinkedField",
                                                    "name": "periods",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTemplatePeriodEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleTemplatePeriod",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": "periods(order:{\"order\":\"ASC\"})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v4 /*: any*/),
                                                    "filters": [
                                                        "order"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ScheduleTemplate_periods",
                                                    "kind": "LinkedHandle",
                                                    "name": "periods"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "767e40e097745cf9527331fe03fd9fce",
            "id": null,
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "cloneScheduleTemplatePeriod",
                            "periodEdge",
                            "node",
                            "scheduleTemplate",
                            "periods"
                        ]
                    }
                ]
            },
            "name": "ScheduleTemplatePeriod_cloneScheduleTemplatePeriodMutation",
            "operationKind": "mutation",
            "text": "mutation ScheduleTemplatePeriod_cloneScheduleTemplatePeriodMutation(\n  $model: CloneScheduleTemplatePeriodRequestInput!\n) {\n  cloneScheduleTemplatePeriod(model: $model) {\n    periodEdge {\n      node {\n        ...ScheduleTemplatePeriod_period\n        scheduleTemplate {\n          id\n          periods(order: {order: ASC}) {\n            edges {\n              node {\n                id\n                ...ScheduleTemplatePeriod_period\n                __typename\n              }\n              cursor\n            }\n            totalCount\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleTemplatePeriodDay_day on ScheduleTemplatePeriodDay {\n  id\n  dayInPeriod\n  weekday\n  period {\n    id\n    scheduleTemplateId\n  }\n  groupedShifts {\n    group {\n      assignmentType {\n        id\n        title\n      }\n    }\n    shiftsGroups {\n      group {\n        startTimeOfDay\n        endTimeOfDay\n        duration(unit: MINUTE) {\n          value\n        }\n        event {\n          id\n          name\n        }\n      }\n      shifts {\n        id\n        duration(unit: HOUR) {\n          value\n        }\n        assignmentType {\n          id\n          title\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n        endTimeOfDay\n        startTimeOfDay\n        ...ScheduleTemplateShift_shift\n      }\n      ...ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift\n    }\n  }\n}\n\nfragment ScheduleTemplatePeriod_period on ScheduleTemplatePeriod {\n  id\n  days {\n    edges {\n      node {\n        id\n        weekday\n        ...ScheduleTemplatePeriodDay_day\n      }\n    }\n  }\n  name\n  scheduleTemplateId\n}\n\nfragment ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift on ScheduleTemplateShiftGroup {\n  shifts {\n    assetValidations {\n      schedulableAsset {\n        asset {\n          id\n          name\n          assetNumber\n          validateProficiency\n        }\n        id\n      }\n      schedulableUser {\n        user {\n          fullName\n          id\n        }\n        id\n      }\n      userAssignmentType {\n        title\n        id\n      }\n      assetProficiency {\n        isValid\n      }\n    }\n    id\n  }\n}\n\nfragment ScheduleTemplateShift_shift on ScheduleTemplateShift {\n  id\n  assignedEntity {\n    __typename\n    ...SchedulableAsset_entity\n    ...SchedulableUser_entity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    id\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "68633728d2b1955e0887afd42b43ae87";
export default node;
